module.exports = __webpack_public_path__ + "static/media/night.8c58d711.svg";